"use client";

import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import { ICampaign } from "@/interfaces/campaign.interface";
import campaignService from "@/services/campaign.service";
import { ByIdRequestProps, RequestsBaseReturn } from "@/types/requests.types";

export type UseGetCampaignByIdReturn = RequestsBaseReturn<ICampaign | null>;

export type UseGetCampaignByIdProps = ByIdRequestProps;

type UseSwrGetCampaignByIdParams = [string, number];

const useGetCampaignById = ({ _id }: UseGetCampaignByIdProps): UseGetCampaignByIdReturn => {
  // Se _id é 0 ou inválido, não fazer fetch e retornar imediatamente
  const shouldFetch = _id && _id > 0;

  const {
    data = null,
    isValidating: isLoading,
    error,
  } = useSWR<ICampaign, Error, UseSwrGetCampaignByIdParams | null>(
    shouldFetch ? [SWR_KEYS.getCampaignById, _id] : null,
    ([, userId]) => campaignService.getById(userId),
    {
      revalidateOnFocus: false,
    }
  );

  // Se não deve fazer fetch, retornar loading como false
  if (!shouldFetch) {
    return { data: null, isLoading: false, error: null };
  }

  return { data, isLoading, error };
};

export default useGetCampaignById;
